"use client";

import { c as _c } from "react/compiler-runtime";
import { MobileVotingModal, VotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import { format } from "date-fns";
import { useState } from "react";
import DropCurationButton from "../DropCurationButton";
import WaveDropReactions from "../WaveDropReactions";
import { ParticipationDropRatings } from "./ParticipationDropRatings";
interface ParticipationDropFooterProps {
  readonly drop: ExtendedDrop;
}
export default function ParticipationDropFooter(t0) {
  const $ = _c(28);
  const {
    drop
  } = t0;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const isMobileScreen = useIsMobileScreen();
  let t1;
  if ($[0] !== canShowVote || $[1] !== drop || $[2] !== isMobileScreen || $[3] !== isVotingModalOpen) {
    t1 = canShowVote && <div className="tw-mt-4 tw-@container sm:tw-ml-[3.25rem]" onClick={_temp}><div className="tw-flex tw-flex-col tw-gap-x-4 tw-gap-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-justify-between"><div className="tw-px-4">{!!drop.raters_count && <ParticipationDropRatings drop={drop} rank={drop.rank} />}</div><div className="tw-flex tw-items-center tw-gap-1.5 tw-w-full tw-justify-center tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-px-6 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-border-none @[700px]:tw-px-4 @[700px]:tw-pt-0"><DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={drop.context_profile_context?.curatable ?? false} isCurated={drop.context_profile_context?.curated ?? false} /><VotingModalButton drop={drop} onClick={() => setIsVotingModalOpen(true)} /></div></div>{isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />}</div>;
    $[0] = canShowVote;
    $[1] = drop;
    $[2] = isMobileScreen;
    $[3] = isVotingModalOpen;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== canShowVote || $[6] !== drop) {
    t2 = !canShowVote && !!drop.raters_count && <div className="tw-ml-[3.25rem] tw-mt-4 tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} /></div>;
    $[5] = canShowVote;
    $[6] = drop;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== canShowVote || $[9] !== drop.context_profile_context?.curatable || $[10] !== drop.context_profile_context?.curated || $[11] !== drop.id || $[12] !== drop.wave) {
    t3 = !canShowVote && <DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={drop.context_profile_context?.curatable ?? false} isCurated={drop.context_profile_context?.curated ?? false} />;
    $[8] = canShowVote;
    $[9] = drop.context_profile_context?.curatable;
    $[10] = drop.context_profile_context?.curated;
    $[11] = drop.id;
    $[12] = drop.wave;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== drop) {
    t4 = <WaveDropReactions drop={drop} />;
    $[14] = drop;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <div className="tw-ml-[3.25rem] tw-mt-4 tw-flex tw-w-[calc(100%-3.25rem)] tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1 tw-px-4">{t3}{t4}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== drop.created_at) {
    t6 = format(new Date(drop.created_at), "h:mm a \xB7 MMM d, yyyy");
    $[19] = drop.created_at;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== t6) {
    t7 = <div className="tw-mt-4 tw-border-t tw-border-iron-800/30 tw-px-4 tw-pb-3 tw-text-[11px] tw-text-iron-500 sm:tw-ml-[3.25rem]">{t6}</div>;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t1 || $[24] !== t2 || $[25] !== t5 || $[26] !== t7) {
    t8 = <>{t1}{t2}{t5}{t7}</>;
    $[23] = t1;
    $[24] = t2;
    $[25] = t5;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  return t8;
}
function _temp(e) {
  return e.stopPropagation();
}